import { __assign } from "tslib";
import * as React from 'react';
var script = document.createElement('script');
script.type = 'text/javascript';
script.id = 'dropboxjs';
var DROPBOX_APP_KEY = window.DROPBOX_APP_KEY;
if (DROPBOX_APP_KEY)
    script.setAttribute('data-app-key', DROPBOX_APP_KEY);
script.src = 'https://www.dropbox.com/static/api/2/dropins.js';
document.body.append(script);
var DropboxUi = function (_a) {
    var url = _a.url, renderWrap = _a.renderWrap;
    var ref = React.useRef();
    React.useLayoutEffect(function () {
        if (!ref.current)
            return;
        var embed = Dropbox.embed({
            link: url,
            file: {
                zoom: "best"
            },
            folder: {
                view: "list",
                headerSize: "normal"
            }
        }, ref.current);
        return function () {
            Dropbox.unmount(embed);
        };
    }, []);
    return renderWrap(React.createElement("div", { ref: ref, style: { height: 500 } }));
};
var WithDropbox = function (props) {
    var _a = React.useState(false), ready = _a[0], setReady = _a[1];
    React.useEffect(function () {
        var mounted = true;
        var wait = function () {
            if (!mounted)
                return;
            if (typeof Dropbox !== 'undefined') {
                setReady(true);
                return;
            }
            setTimeout(wait, 100);
        };
        wait();
        return function () {
            mounted = false;
        };
    }, []);
    if (!ready)
        return null;
    return React.createElement(DropboxUi, __assign({}, props));
};
export default WithDropbox;
//# sourceMappingURL=index.js.map